import markingEnum from "@/utils/enums/markingEnum";
import util from '@/v2/utils/util'
export const markingData = {
  fixQuestionGroupNum: (resp) => {
    const task = resp.body
    if (task) {
      task.assignType = markingEnum.AssignType.indexOf(task.assignType)
      task.judgeType = markingEnum.AssignType.indexOf(task.judgeType)
      task.type = markingEnum.GradingTimes.indexOf(task.type)
      task.pauseStatus = markingEnum.PauseStatus.indexOf(task.pauseStatus)
      task.gradingNumInfo = {
        firstTeachersInfo: []
      }
      for (let index = 0; index < task.firstTeachers.length; index++) {
        const { schoolId, schoolName, teacherId, teacherName, todoGradingNum } = task.firstTeachers[index];
        task.gradingNumInfo.firstTeachersInfo.push({
          gradingNum: task.teacherMaxGradingNumMap[teacherId],
          schoolId, schoolName, teacherId, teacherName, todoGradingNum
        })
      }
    }
    return resp
  },
  fixWuHenSet: (resp, key = 'gradingTasks') => {
    if (resp.body) {
      resp.body.isGrading = markingEnum.GradingStatus.indexOf(resp.body.isGrading)
      resp.body.examStatus = markingEnum.GradingStatus.indexOf(resp.body.memberStatus)
      resp.body.assignType = markingEnum.AssignMode.indexOf(resp.body.assignMode)
      for (let index = 0; index < resp.body[key].length; index++) {
        const task = resp.body[key][index]
        task.assignType = markingEnum.AssignType.indexOf(task.assignType)
        task.judgeType = markingEnum.AssignType.indexOf(task.judgeType)
        task.type = markingEnum.GradingTimes.indexOf(task.type)
        task.pauseStatus = markingEnum.PauseStatus.indexOf(task.pauseStatus)
      }

      resp.body.schoolList = resp.body.schoolsOfRegion || resp.body.examGradingSchools
      if (resp.body.subjectiveStands) {
        resp.body.subjectiveStands.forEach(item => {
          item.images = item.standRanges.map(s => s.ossUrl)
          item.isChecked = false
        })
        const pointArr = resp.body.subjectiveStands.map((item) => item.score)
        resp.body.maxScore = Math.ceil(Math.max(...pointArr))
      }

      if (resp.body.gradingTasks) {
        resp.body.gradingTasks.forEach(item => {
          // 取最小值
          item.point = item.questions ? item.questions.reduce((min, current) => { return current.score < min ? current.score : min }, item.questions[0].score) : 0
          item.nums = item.questions ? item.questions.map(s => util.standardQuestionNumber(s)).join(',') : '--'
          item.schoolIds = item.allocationSchools ? item.allocationSchools.filter(s => s.isSelected === 1).map(s => s.schoolId) : []
          item.assignNum = item.allocationSchools ? item.allocationSchools.reduce((sum, e) => sum + Number(e.assignNum || 0), 0) : 0
          item.schoolNum = item.schoolIds.length
          item.schoolsOfRegion = resp.body.schoolList
        })
      }
    }
    return resp
  },
  trySetParams (params) {
    try {
      params.assignType = markingEnum.AssignType[params.assignType]
      params.judgeType = markingEnum.AssignType[params.judgeType]
      params.type = markingEnum.GradingTimes[params.type]
    } catch (error) { }
  }
}